import Actions from "./constants";
import { IYouVisitAnalytics, IActionObject } from "./types";

const INITIAL_STATE: IYouVisitAnalytics = {
  pageTitle: "",
  isReady: false,
  font: {
    hasCustomFonts: false,
    customFonts: null,
  },
  experienceUpdated: "",
  registration: {
    enabled: true,
    testing: false,
    userkey: null,
    mobile: false,
    autoLaunch: false,
    launchTime: 0,
    form: null,
    hasRegisteredUser: true,
    formType: "cif",
  },
  analytics: {
    disabled: false,
    hasCookieConsent: true,
    module: null,
    userkey: null,
    sessionId: null,
    sessionType: "registration",
    analyticsTime: null,
    source: null,
    originalSource: null,
    platform: "",
  },
  isPersonalizationEnabled: false,
  isExperienceOffline: false,
  isExperienceNotFound: false,
};

export default function tourReducer(
  state = INITIAL_STATE,
  action: IActionObject
): IYouVisitAnalytics {
  switch (action.type) {
    case Actions.SET_ANALYTICS_CONFIG: {
      // translate snakecase to camelcase
      const mutateData = {
        ...action.data,
        analytics: {
          ...action.data.analytics,
          sessionType: action.data.analytics
            ? action.data.analytics.session_type
            : "registration",
          source: action.data.analytics
            ? action.data.analytics.platform || action.data.analytics.source
            : "web",
          originalSource: action.data.analytics
            ? action.data.analytics.original_platform ||
              action.data.analytics.originalSource
            : "web",
        },
        experienceUpdated: action.data.experience_updated,
      };
      return { ...state, ...mutateData };
    }
    case Actions.SET_IS_REGISTERED: {
      const { registration, ...rest } = state;
      return {
        ...rest,
        registration: { ...registration, hasRegisteredUser: true },
      };
    }
    case Actions.SET_PERSONALIZATION_ENABLED:
      return { ...state, isPersonalizationEnabled: action.data };
    case Actions.SET_EXPERIENCE_OFFLINE:
      return { ...state, isExperienceOffline: action.data };
    case Actions.SET_EXPERIENCE_NOT_FOUND:
      return { ...state, isExperienceNotFound: action.data };
    default:
      return state;
  }
}
